import React from 'react';
import {connect} from 'react-redux';
import Icon from './icons/Icon';
import moment from 'moment';
import Link from './Link';

class CommunityEvents extends React.Component {
    render() {
        if (!this.props.event._isCommunity) {
            return null;
        }

        let {i18n, event} = this.props,
            classes = ['CommunityEvents', this.props.className];

        if (!event?.subevents?.length) {
            return null;
        }

        if (this.props.nextEvent) {
            let nextHref;
            if (this.props.nextEvent.joined) {
                nextHref = ['/events', this.props.nextEvent.id].join('/');
            } else {
                nextHref = ['/events', this.props.event.id, 'subevent', this.props.nextEvent.id].join('/');
            }

            return (
                <table className={classes.join(' ')}>
                    <tbody>
                        <tr>
                            <td
                                style={{
                                    width: '50%',
                                    color: event.settings.primary_color,
                                }}>
                                <Link href="./agenda">
                                    <Icon src="img/calendar_icon.png" color={event.settings.primary_color} /> {i18n['label.events-agenda']}
                                </Link>
                            </td>
                            <td
                                style={{
                                    width: '50%',
                                    backgroundColor: event.settings.primary_color,
                                    color: 'white',
                                    textAlign: 'left',
                                    fontWeight: 'normal',
                                }}>
                                <Link href={nextHref}>
                                    <div>
                                        <div>{i18n['label.event-next']}</div>
                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                        <div>
                                            <b>{moment(this.props.nextEvent.start).format('ll')}</b>
                                        </div>
                                        <div>{this.props.nextEvent.name}</div>
                                    </div>
                                </Link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            );
        } else {
            return (
                <div className="content whitebg">
                    <Link href="./agenda">
                        <h2
                            className="next text-center"
                            style={{
                                color: event.settings.primary_color,
                                textTransform: 'uppercase',
                            }}>
                            {i18n['label.events-agenda']}
                        </h2>
                    </Link>
                </div>
            );
        }
    }
}

export default connect((state, props) => {
    let now = moment(),
        nextEvent = _(props.event.subevents)
            .filter(event => {
                return moment(event.start) >= now || moment(event.end) >= now;
            })
            .sortBy('start')
            .first();
    return {nextEvent};
})(CommunityEvents);
